"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// Registers Preact custom elements
var preact_custom_element_1 = __importDefault(require("preact-custom-element"));
var AddressSearch_1 = require("./components/AddressSearch");
var jquery_1 = __importDefault(require("jquery"));
// @ts-ignore
window.$ = jquery_1.default;
require("select2");
(0, preact_custom_element_1.default)(AddressSearch_1.AddressSearch, 'y-address-search', [], { shadow: false });
